<span class="location-chip" [class.location-chip--inactive]="!location.isActive">
  <i class="material-icons location-chip__icon">place</i>
  <span class="location-chip__label">{{ location.name }}</span>
</span>
